import { Easing, Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import ElementComponent from '../../../Component/UI/Element';
import Renderable from '../../../Component/Renderable';
import { delay } from '../../../Utility/Task/TaskQueue';

export class SuitcaseShowInfo extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        for (let i = 0; i < 3; i++) {
            this.showInfo(gameObject, i);
            yield* delay(100);
        }
        yield* delay(400);
    }

    private showInfo(gameObject: GameObject, index: number) {
        const BOTTOM: string = 'bottom_container';
        const BOOSTERS: string = `${BOTTOM}/suitcase_boosters`;
        const TICKETS: string = `${BOOSTERS}/tickets_mask/tickets_container`;
        const INFOS: string = `${BOOSTERS}/infos`;

        const ticket = gameObject.find(`${TICKETS}/ticket${index + 1}`);
        const info = gameObject.find(`${INFOS}/info${index + 1}`);

        if (ticket.getComponent(Renderable).visible) {
            info.getComponent(Renderable).visible = true;

            const element: ElementComponent = info.getComponent(
                ElementComponent
            );
            element.scale.set(0, 0);

            const scaleTween: Tween = this.getTween(element.scale);
            scaleTween
                .to({ x: 1, y: 1 }, 500)
                .easing(Easing.Bounce.Out)
                .start(this.elapsedTime);
        }
    }
}
